import {
  UserCurrencyModel,
  UserModel,
  UserResellerModel,
} from '@/modules/AccountPage/models/UserModel'
import { PaymentsProductModel } from '../../Payments/models/PaymentsModel'
export class LicenseVersionsPricesModel {
  licenseId?: string = ''
  deviceSerial?: string = ''
  discountCode = ''
  timePeriodId?: string = ''
  licenseVresionIds?: string[] = []
}

export class LicenseVersionModel {
  id = ''
  name = ''
}

export class LicenseVersionsLatestModel {
  id = ''
  name = ''
  sequentialId = 0
  serialNumber = ''
  customerName = ''
  customerSurname = ''
  customerFarm = ''
  countryCode = 0
  customerEmail = ''
  customerPhone = ''
  customerAddress = ''
  note = ''
  companyCode = ''
  activationDate: Date | string = ''
  expirationDate: Date | string = ''
  product: PaymentsProductModel | null = null
  productId = ''
  user: UserModel | null = null
  userId = ''
  resellerId = ''
  reseller: UserResellerModel = new UserResellerModel()
  versionId = ''
  version: LicenseVersionModel | null = null
  stateId = ''
  deleted = true
}

export class LicenseVersionsProductModel {
  isAlreadyActive = false
  isAvaialbleToRenew = false
  isTrialAvailable = false
  latestLicense: LicenseVersionsLatestModel | null = null
  latestLicenseId: string | null = null
  licenseVersion: LicenseVersionModel = new LicenseVersionModel()
  licenseVersionId = ''
}

export class LicenseVersionsWithOptionsPricesModel {
  coinsPrice = 0
  currency: UserCurrencyModel = new UserCurrencyModel()
  currencyId = ''
  isAlreadyActive = false
  isAvaialbleToRenew = false
  isFree = false
  isTrial = false
  latestLicense: LicenseVersionsLatestModel | null = null
  latestLicenseId: string | null = null
  licenseVersion: LicenseVersionModel | null = null
  licenseVersionId = ''
  timePeriodId = ''
}
export class LicenseVersionsWithOptionsModel {
  prices: LicenseVersionsWithOptionsPricesModel[] = []
}
